module.exports = __webpack_public_path__ + "images/loginin_bg.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loginin_bg.jpg
// module id = 378
// module chunks = 2